//@flow
import * as React from 'react';
import { useLocation, Redirect } from 'react-router-dom';

import useSession from 'common/hooks/useSession';

const ClientUrlRedirectContainer = (): React.Node => {
    const location = useLocation();
    const session = useSession();

    const { pathname, search } = location;
    const redirectUrl = `/client/${session.dataClientId + pathname + search}`;
    return <Redirect to={redirectUrl} push />;
};

export default ClientUrlRedirectContainer;
